import { useState, useEffect } from 'react';
import { MediaDetails } from 'types/CommonTypes';

const calculateRatio = (imageDetails: MediaDetails) => {
    return imageDetails.height / imageDetails.width;
};

export function useImageRatio(imageDetails: MediaDetails) {
    const [ratio, setRatio] = useState(0);
    const resizeListener = () => {
        globalThis.window && setRatio(calculateRatio(imageDetails));
    };

    useEffect(() => {
        resizeListener();

        window.addEventListener('resize', resizeListener);

        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);
    return ratio;
}
